module.exports = __webpack_public_path__ + "img/tel_icon.72bde0a7.png";